
import moment from "moment";
import { CommonDestinationTimezone } from '@/lib/utils';

export function generateCurrentDefaultCommodityYear() {
    return moment.tz(CommonDestinationTimezone).startOf("month").subtract(3, "month").format("YYYY");
}
